var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEglence(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#CFA031"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.086 16.128l4.93-1.692c.754-.256.972-1.184.405-1.728L8.95 10.335c-.568-.545-1.528-.335-1.8.387l-1.762 4.736c-.153.419.262.817.698.67zM12.125 11.262l2.76-2.65a.701.701 0 01.965 0l.033.03c.158.153.42.153.578 0a.384.384 0 000-.554l-.033-.032a1.549 1.549 0 00-2.122 0l-2.76 2.65a.384.384 0 000 .556c.159.152.42.152.579 0zM9.397 8.58l-.032.031a.384.384 0 000 .556c.158.152.42.152.578 0l.033-.032a1.404 1.404 0 000-2.037l-.028-.027a.42.42 0 00-.583 0 .384.384 0 000 .556l.032.031a.64.64 0 010 .922zM13.214 11.2l-.578.554a.384.384 0 000 .556c.158.151.42.151.578 0l.579-.556a.701.701 0 01.965 0l.59.566c.157.152.42.152.577 0a.384.384 0 000-.555l-.589-.566a1.549 1.549 0 00-2.122 0zM12.124 8.056l-1.67 1.603a.384.384 0 000 .555c.159.152.42.152.579 0l1.669-1.602a1.404 1.404 0 000-2.038l-.578-.555a.424.424 0 00-.579 0 .384.384 0 000 .555l.579.555a.645.645 0 010 .927z",
    fill: "#fff"
  })));
}
export default SvgEglence;